export default __webpack_public_path__ + "static/media/Book6.0bc118af.webp";